import { useContext } from 'react'

import Cookies from 'js-cookie'
import dynamic from 'next/dynamic'

import { authorize } from 'api/utils'
import { domainLocales } from 'domainLocales'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { BEARER_TOKEN_COOKIE, IS_SSOV2_ENABLED } from 'interfaces/constants'
import { actionTypes } from 'state/actionTypes'
import { AppContext } from 'state/appContext'

const SSOV2 = dynamic(
  () => import('@hhgtech/hhg-components/ssoV2').then((m) => m.SSOV2),
  {
    ssr: false,
  },
)
export const SSOV2Wrapper = () => {
  const { locale } = useRouterExtend()
  const { state, dispatch } = useContext(AppContext)
  if (!IS_SSOV2_ENABLED) return null
  const { userInfo } = state
  const onClose = () => {
    if (!userInfo?.id && Cookies.get(BEARER_TOKEN_COOKIE)) {
      ;(async () => {
        const user = await authorize()
        if (user?.id) {
          dispatch({
            type: actionTypes.LOGIN,
            payload: user,
          })
        } else {
          dispatch({
            type: actionTypes.LOGOUT,
            payload: {
              domain: '.' + domainLocales[locale],
            },
          })
        }
      })()
    } else if (userInfo?.id && !Cookies.get(BEARER_TOKEN_COOKIE)) {
      dispatch({
        type: actionTypes.LOGOUT,
        payload: {
          domain: '.' + domainLocales[locale],
        },
      })
    } else {
      dispatch({
        type: actionTypes.INIT_USER,
      })
    }
  }
  return <SSOV2 onClose={onClose} locale={locale} />
}
